<template>
  <form
    class="fff-modal add-food-modal"
    @submit.prevent="submit"
  >
    <div
      class="overlay"
      @click="hide"
    />
    <div class="box">
      <div
        class="close-modal"
        @click="hide"
      >
        &times;
      </div>
      <div class="field">
        <h2>Add {{ iteminfo.meal_name ? iteminfo.meal_name : 'Meal' }}</h2>
      </div>
      <div class="field horizontal">
        <div><label for="add_meal_date">Date</label></div>
        <div>
          <date-picker
            v-model="add_meal_data.date"
            button-class="w-100 border-secondary"
            hidenav="hide"
          />
        </div>
      </div>
      <div class="field horizontal">
        <div><label for="serving_size">Serving</label></div>
        <div>
          <input
            id="serving_size"
            v-model="add_meal_data.serving_size"
            type="text"
            class="fff-ui"
            placeholder="eg, 2"
          >
        </div>
        <div style="flex: 3;">
          <div class="select-container">
            <select
              v-if="add_meal_data.serving_unit!='g' && add_meal_data.serving_unit!='g.'"
              v-model="add_meal_data.serving_unit"
              class="fff-ui"
            >
              <option value="">
                Choose a Unit
              </option>
              <option value="teaspoon">
                {{ friendly_units['teaspoon'] }}
              </option>
              <option value="tablespoon">
                {{ friendly_units['tablespoon'] }}
              </option>
              <option value="cp">
                {{ friendly_units['cp'] }}
              </option>
              <option value="pt">
                {{ friendly_units['pt'] }}
              </option>
              <option value="qt">
                {{ friendly_units['qt'] }}
              </option>
              <option value="gal">
                {{ friendly_units['gal'] }}
              </option>
              <option value="floz">
                {{ friendly_units['floz'] }}
              </option>
              <option value="g">
                {{ friendly_units['g'] }}
              </option>
              <option value="lb">
                {{ friendly_units['lb'] }}
              </option>
            </select>
            <select
              v-else
              class="fff-ui"
            >
              <option value="g">
                {{ friendly_units['g'] }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="field horizontal">
        <div><label for="add_meal_date">Meal</label></div>
        <div>
          <div class="select-container">
            <select
              v-model="add_meal_data.meal"
              class="fff-ui"
            >
              <option value="">
                Choose a Meal
              </option>
              <option value="breakfast">
                Breakfast
              </option>
              <option value="lunch">
                Lunch
              </option>
              <option value="dinner">
                Dinner
              </option>
              <option value="snack">
                Snack
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="button-container fluid">
        <button
          type="submit"
          class="button fluid"
        >
          Submit
        </button>
      </div>
    </div>
    <date-modal
      v-show="is_showing_date_modal"
      :date="add_meal_data.date"
      :hidenav="hidenav"
      @hide-modal="is_showing_date_modal = false"
      @choose-date="update_date"
    />
  </form>
</template>

<script>
import {FRIENDLY_UNITS} from "../recipe_maker_vars";
import DatePicker from "./DatePicker";

export default {
  components: {DatePicker},
  props:{
    iteminfo:Object
  },
  data () {
    return {
      is_showing_date_modal: false,
      hidenav: 'hide',
      add_meal_data: {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1).split('T')[0],
        serving_size: '1.00',
        serving_unit: '',
        meal: this.$store.state.selection.mealType,
        food_items_sid:'',
        food_item_spirals_sid:'',
        food_recipe_id:'',
        type:'',
        type_of_food:'',
        color:''
      },
      friendly_units: FRIENDLY_UNITS,
    }
  },
  computed: {
    mealType : function () {
      return this.add_meal_data.meal;
    },
  },
  watch:{
    iteminfo: function(newVal, oldVal){
      this.add_meal_data.type = newVal.type;
      this.add_meal_data.food_items_sid = newVal.food_items_sid;
      this.add_meal_data.food_item_spirals_sid = newVal.food_item_spirals_sid;
      this.add_meal_data.food_recipe_id = newVal.food_recipe_id;
      this.add_meal_data.serving_unit = newVal.serving_unit;
      this.add_meal_data.serving_size = newVal.serving_size;
      this.add_meal_data.type_of_food = newVal.type_of_food;
      this.add_meal_data.color = newVal.color;
    },
    mealType: function(newVal, oldVal) {
      this.$store.dispatch('selection/setMealType', newVal);
    }
  },
  methods: {
    hide() {
      this.$emit('hide-modal');
    },
    async submit() {
      // Submit the meal to the API
      if(this.add_meal_data.meal==''){
        return alert("Please select a Meal option from the list.");
      } else if (this.add_meal_data.serving_unit==''){
        return alert("Please select a Serving Unit from the list.");
      } else if (isNaN(parseFloat(this.add_meal_data.serving_size)) || !isFinite(this.add_meal_data.serving_size)){
        return alert("Please enter a number for the Serving Size.");
      }

      const fetchResponse = await this.$http('/api/meals/addmeal',{
        method:"post",
        body:JSON.stringify({
          'type':this.add_meal_data.type,
          'food_items_sid':this.add_meal_data.food_items_sid,
          'food_item_spirals_sid':this.add_meal_data.food_item_spirals_sid,
          'food_recipe_id':this.add_meal_data.food_recipe_id,
          'date':this.add_meal_data.date,
          'serving_size_unit':this.add_meal_data.serving_unit,
          'serving_size_value':this.add_meal_data.serving_size,
          'meal':this.add_meal_data.meal,
          'type_of_food':this.add_meal_data.type_of_food,
          'color':this.add_meal_data.color
        }),
      });
      const jsonResponse = await fetchResponse.json();

      if (jsonResponse.id) {
        this.$emit('meal-log-entry-added');
      } else {
        alert("There was an error adding your meal entry, please try again.");
      }

      this.hide();
    },
    update_date(date) {
      this.add_meal_data.date = date;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
